module.exports = __webpack_public_path__ + "media/components/insights/asset-icons/project-95132acedf1c75ea9013b94bfc4d7e70.png";